/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractLanguageSupportedDto } from '../../models/contract-language-supported-dto';

export interface ContractCheckLanguageIsSupported$Params {
  languageSelected?: string;
}

export function contractCheckLanguageIsSupported(http: HttpClient, rootUrl: string, params?: ContractCheckLanguageIsSupported$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractLanguageSupportedDto>> {
  const rb = new RequestBuilder(rootUrl, contractCheckLanguageIsSupported.PATH, 'get');
  if (params) {
    rb.query('languageSelected', params.languageSelected, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractLanguageSupportedDto>;
    })
  );
}

contractCheckLanguageIsSupported.PATH = '/v1/Contract/CheckLanguageIsSupported';
